import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3e3b8a8e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=3e3b8a8e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3b8a8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\xc\\integrated-business-and-finance-wechat\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e3b8a8e')) {
      api.createRecord('3e3b8a8e', component.options)
    } else {
      api.reload('3e3b8a8e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3e3b8a8e&scoped=true", function () {
      api.rerender('3e3b8a8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/crm/client/index.vue"
export default component.exports